import React from 'react';
import {
  Card,
  Row,
  Col,
  Select,
  InputNumber,
  Typography
} from 'antd';

const { Option } = Select;
const { Text } = Typography;

const DiscountSection = ({
  discount,
  onDiscountChange,
  subtotal = 0,
  readOnly = false
}) => {
  const calculateDiscountAmount = () => {
    if (discount.type === 'percentage') {
      return subtotal * (discount.value / 100);
    } else if (discount.type === 'fixed') {
      return discount.value;
    }
    return 0;
  };

  return (
    <Card title="Discount (Optional)" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text>Discount Type</Text>
          </div>
          <Select 
            value={discount.type} 
            onChange={(value) => onDiscountChange({ type: value, value: 0 })}
            style={{ width: '100%' }}
            disabled={readOnly}
          >
            <Option value="none">No Discount</Option>
            <Option value="percentage">Percentage (%)</Option>
            <Option value="fixed">Fixed Amount (SGD)</Option>
          </Select>
        </Col>
        <Col span={8}>
          {discount.type !== 'none' && (
            <>
              <div style={{ marginBottom: 8 }}>
                <Text>{discount.type === 'percentage' ? 'Percentage' : 'Amount'}</Text>
              </div>
              <InputNumber
                min={0}
                max={discount.type === 'percentage' ? 100 : undefined}
                precision={discount.type === 'percentage' ? 2 : 2}
                value={discount.value}
                onChange={(value) => onDiscountChange({ ...discount, value: value || 0 })}
                style={{ width: '100%' }}
                formatter={discount.type === 'percentage' 
                  ? (value) => `${value}%`
                  : (value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={discount.type === 'percentage'
                  ? (value) => value.replace('%', '')
                  : (value) => value.replace(/\$\s?|(,*)/g, '')
                }
                disabled={readOnly}
              />
            </>
          )}
        </Col>
        <Col span={8}>
          {discount.type !== 'none' && (
            <>
              <div style={{ marginBottom: 8 }}>
                <Text>Discount Amount</Text>
              </div>
              <Text strong style={{ color: '#52c41a' }}>
                -${calculateDiscountAmount().toFixed(2)}
              </Text>
            </>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default DiscountSection;
